module.exports = __webpack_public_path__ + "media/images/img-eatout-6-6ca1bf43.jpg";